import React from "react";
import { LinearProgress, styled } from "@mui/material";



// Estilização personalizada para o LinearProgress
const StripedLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 30,
    borderRadius: 5,
    width: '100%',
    overflow: 'hidden',
    '.MuiLinearProgress-bar': {
        background:
            `repeating-linear-gradient(
        45deg,#dd3447,
        #dd3447 10px,
        #de5461 10px,
        #de5461 20px
    )`,
    },
}));

const StripedProgressComponent = ({ value }) => {
    return (
        <div style={{ width: "100%" }}>
            <StripedLinearProgress variant="determinate" value={value} />
        </div>
    );
};

export default StripedProgressComponent;
